import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/feature/Reveal';
import { fitFor, notFitFor } from '@/mocks/deliverables';

export default function FitSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-shell mx-auto">
          <Reveal>
            <SectionHeading
              eyebrow="Is this for you?"
              title="GoldWarden is not built for everyone"
              subtitle="Honestly, this tool is better for some traders than others. Read both columns before you ask for it — it saves us both time."
            />
          </Reveal>

          <div className="mt-10 md:mt-12 grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
            <Reveal>
              <div className="h-full rounded-lg border border-primary-200 bg-primary-50 p-6 md:p-7">
                <div className="flex items-center gap-3">
                  <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                    <i className="ri-check-double-line text-xl" aria-hidden="true"></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">
                      A good fit if…
                    </h3>
                    <p className="text-xs text-foreground-600">You will probably get value out of it</p>
                  </div>
                </div>

                <ul className="mt-6 flex flex-col gap-4">
                  {fitFor.map((item) => (
                    <li key={item.id} className="flex gap-3.5">
                      <span className="shrink-0 w-9 h-9 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                        <i className={`${item.icon} text-lg`} aria-hidden="true"></i>
                      </span>
                      <div>
                        <p className="text-sm font-semibold text-foreground-950">{item.title}</p>
                        <p className="mt-1 text-xs md:text-sm leading-relaxed text-foreground-600">{item.text}</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>

            <Reveal delay={100}>
              <div className="h-full rounded-lg border border-secondary-200 bg-secondary-100 p-6 md:p-7">
                <div className="flex items-center gap-3">
                  <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-secondary-500 text-background-50">
                    <i className="ri-close-line text-xl" aria-hidden="true"></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">
                      Probably not for you if…
                    </h3>
                    <p className="text-xs text-foreground-600">You would likely be disappointed</p>
                  </div>
                </div>

                <ul className="mt-6 flex flex-col gap-4">
                  {notFitFor.map((item) => (
                    <li key={item.id} className="flex gap-3.5">
                      <span className="shrink-0 w-9 h-9 flex items-center justify-center rounded-md bg-secondary-200 text-secondary-800">
                        <i className={`${item.icon} text-lg`} aria-hidden="true"></i>
                      </span>
                      <div>
                        <p className="text-sm font-semibold text-foreground-950">{item.title}</p>
                        <p className="mt-1 text-xs md:text-sm leading-relaxed text-foreground-600">{item.text}</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}